import * as THREE from 'three';

import { CONTAINER, DPI, DEBUG } from '@/scripts/stage/constants';

const glCanvas = document.createElement('canvas');
const renderer = new THREE.WebGLRenderer({ canvas: glCanvas, antialias: DPI === 1, alpha: false });

renderer.setPixelRatio(DPI);
renderer.debug.checkShaderErrors = DEBUG;
renderer.setSize(window.innerWidth, window.innerHeight);

CONTAINER.appendChild(glCanvas);

window.renderer = renderer;

export default renderer;
